import TextGradient from "@app/components/gradient/gradient-text";
import Image from "next/image";
import GradientContainer from "@app/components/gradient/gradient-container";

const AboutPage = () => {
  return (
    <div className="pb-10">
      <div className="px-8 py-12 md:p-12 lg:p-24">
        <div className="grid grid-cols-12 max-w-[1440px] mx-auto md:gap-x-10 lg:gap-x-16 xl:gap-x-24">
          <div className="col-span-12 md:col-span-6 xl:col-span-6 flex flex-col justify-center items-end gap-y-4">
            <div className="flex flex-col gap-y-4 text-left w-full">
              <TextGradient overrideClassName="mobile-h2 md:h3 xl:h2 2xl:h1 py-2">
                A new kind of waste management company
              </TextGradient>
              <span className="text-body-xl text-text-color-mid-em">
                — We’ve formed a powerful ecosystem that empowers and connects
                key industry stakeholders using technological innovation.
              </span>
            </div>
          </div>
          <div className="col-span-12 md:col-span-6 xl:col-span-6 flex items-center justify-center">
            <div className="w-4/5 pt-10 md:pt-0 md:w-full">
              <Image
                className="rounded-lg"
                src="/images/about/lady.png"
                alt="Waste Management"
                width={560}
                height={599}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-background-low-em py-8 px-10 md:py-16 lg:px-20 text-center space-y-4">
        <p className="text-secondary-dark text-body-xl-medium">About us</p>
        <h2 className="h4 lg:h2 text-background-primary-dark">
          About Simplewaste
        </h2>
        <div className="flex justify-center">
          <GradientContainer overrideClassName="w-[200px] h-2" />
        </div>
        <p className="text-text-color-mid-em text-body-sm md:text-body-md lg:text-body-xl">
          Learn more about the company and the team behind it.
        </p>
        <div className="text-start pt-8 space-y-4 lg:space-y-10 flex flex-col xl:items-center">
          <div className="space-y-1 xl:w-[1120px]">
            <p className="text-secondary-dark text-body-xl-medium">
              Who we are
            </p>
            <h4 className="h5 text-text-color-high-em">
              Waste Management Company
            </h4>
          </div>
          <div
            className="space-y-4 lg:space-y-0 lg:flex lg:items-start lg:justify-center 
          lg:space-x-16 "
          >
            <p className="text-text-color-mid-em text-body-md lg:subheading lg:w-[494px]">
              At SimpleWaste we’ve combined the best aspects of technology,
              expertise, and support to create an unmatched user experience.
            </p>
            <div className="w-20 h-1 bg-text-color-disabled lg:w-1 lg:h-20" />
            <p className="text-text-color-mid-em text-body-md lg:subheading lg:w-[494px]">
              Our goal is to transform outdated infrastructure, with its
              inefficient methods of operation, and to deliver waste and
              recycling services as they should be delivered, with proficient
              simplicity.
            </p>
          </div>
        </div>
      </div>
      <div className="pb-6 sm:p-10 lg:py-16 lg:px-20 xl:px-32 xl-2:!px-20">
        <div className="lg:bg-background-primary-dark-dark lg:rounded-2xl lg:relative">
          <div
            className="flex items-center bg-cover bg-center justify-end
            sm:rounded-2xl sm:shadow-lg lg:bg-right lg:rounded-r-none
            w-full lg:h-[864px] lg:w-[640px] 
            3xl:!w-1/2"
            style={{
              backgroundImage: "url('/images/about/building.jpeg')",
            }}
          >
            <div
              className="bg-white p-6 my-10 lg:my-0 xs:rounded-lg
            xs:w-2/3 md:w-3/5 lg:w-[515px] xl:w-[624px] 
            lg:p-8 lg:absolute lg:right-36 2xl:right-1/4 3xl:right-1/3"
            >
              <div className="space-y-4">
                <h4 className="h5 sm:h4 lg:h3 text-text-color-high-em">
                  Our Company
                </h4>
              </div>
              <GradientContainer overrideClassName="w-[150px] h-2 mt-6" />
              <div
                className="pt-6 space-y-6 text-text-color-high-em 
              text-body-md sm:text-body-xl"
              >
                <p>
                  SimpleWaste is a national Waste & Recycling Management Company
                  providing specialized technology and service to all commercial
                  and residential sectors.
                </p>
                <p>
                  Our management platform provides a user interface that
                  combines dynamic purchasing automation, intuitive
                  functionality, and ease-of-use. This powerful combination
                  delivers maximum value and unmatched user experience.
                </p>
                <p>
                  Our technology innovation provides a distinct industry
                  advantage to customers, vendors, and partners.
                </p>
                <p>
                  Companies that utilizes our platform benefit through
                  data-driven insights, performance optimization, cost control,
                  and cost reduction.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sm:pt-10 sm:px-10 lg:pt-0 lg:pb-10 lg:px-20 xl:px-32 xl-2:!px-20">
        <div className="lg:bg-background-low-em lg:rounded-2xl lg:flex lg:justify-end lg:relative">
          <div
            className="flex items-center bg-cover bg-center
            sm:rounded-2xl sm:shadow-lg lg:rounded-l-none
            w-full lg:h-[864px] lg:w-[640px]
            3xl:!w-1/2"
            style={{
              backgroundImage: "url('/images/about/mountain.jpeg')",
            }}
          >
            <div
              className="bg-white my-10 lg:my-0 w-full p-6 xs:rounded-lg
            xs:w-2/3 md:w-3/5 lg:w-[515px] xl:w-[624px]
            lg:p-8 lg:absolute lg:left-10 xl:left-36 2xl:left-64 3xl:left-1/3"
            >
              <div className="space-y-4">
                <h4 className="h5 sm:h4 lg:h3 text-text-color-high-em">
                  Our Outlook
                </h4>
              </div>
              <GradientContainer overrideClassName="w-[150px] h-2 mt-6" />
              <div
                className="pt-6 space-y-6 text-text-color-high-em text-body-md 
                sm:text-body-xl"
              >
                <p>
                  At SimpleWaste we’re elevating the future of waste management through
                  innovation. Our platform and service suite is designed to provide an
                  unmatched SaaS experience that’s both dynamic and simplistic.
                </p>
                <p>
                  Our business model offers a perfect blend of technology,
                  industry representation, direct savings, and customer support.
                  At the end of the day, our goals are achieved through our
                  principal drive for excellence.
                </p>
                <p>
                  We continue to update our user’s experience through
                  technological advancement and industry alignment.
                </p>
                <p>
                  We’re increasing value-added services through persistent
                  growth, market-share, and subsidiary expansion.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
